const MEDIA_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20elegant%20costumes%2C%20warm%20lighting%2C%20cinematic%20composition%2C%20film%20poster%20style%2C%20rich%20amber%20tones%2C%20professional%20photography%2C%20ancient%20Chinese%20palace%20atmosphere&width=800&height=450&seq=media-01&orientation=landscape',
    title: '古装权谋大剧火热更新中',
    duration: '更新至38集',
    views: '1280万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20explosion%20scene%20with%20dramatic%20lighting%2C%20cinematic%20photography%2C%20warm%20orange%20tones%2C%20film%20poster%20style%2C%20intense%20atmosphere%2C%20professional%20movie%20aesthetic%2C%20dynamic%20composition&width=800&height=450&seq=media-02&orientation=landscape',
    title: '好莱坞动作巨制限时上线',
    duration: '2小时15分',
    views: '960万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20scene%20with%20vibrant%20colors%2C%20Japanese%20animation%20style%2C%20warm%20atmosphere%2C%20cinematic%20composition%2C%20beautiful%20background%2C%20professional%20anime%20aesthetic%2C%20emotional%20mood&width=800&height=450&seq=media-03&orientation=landscape',
    title: '人气新番动画每周同步更新',
    duration: '更新至第12话',
    views: '850万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20soft%20warm%20lighting%2C%20cinematic%20photography%2C%20film%20poster%20aesthetic%2C%20emotional%20atmosphere%2C%20gentle%20amber%20tones%2C%20professional%20drama%20visual&width=800&height=450&seq=media-04&orientation=landscape',
    title: '高分韩剧全集一次看过瘾',
    duration: '全16集',
    views: '750万次播放',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Comedy%20variety%20show%20studio%20scene%20with%20colorful%20lighting%2C%20entertainment%20program%20aesthetic%2C%20warm%20atmosphere%2C%20professional%20TV%20production%2C%20happy%20mood%2C%20cinematic%20photography&width=800&height=450&seq=media-05&orientation=landscape',
    title: '热门综艺笑料不断超解压',
    duration: '更新至09期',
    views: '680万次播放',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          精彩视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          热播内容精选，点击即刻开始观影
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MEDIA_ITEMS.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 group cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-black/60 text-background-50 text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.views}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {MEDIA_ITEMS.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 group cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-56 aspect-video sm:aspect-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-black/60 text-background-50 text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 flex flex-col justify-center">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.views}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}